<template>
    <div>
        <section class="contact">
            <div class="container section-content">
                <h2 class="title">
                    <span>Contact Us</span>
                </h2>
                <div class="contact-content">
                    <div class="form-block">
                        <div class="form">
                            <input
                                class="iti iti-pad"
                                :style="{
                                    'border-color': validName === 'visible' ? 'red' : '',
                                }"
                                type="text"
                                name="name"
                                placeholder="Name"
                                v-model="input.name"
                            />
                            <span class="validation-error" :style="{ visibility: validName }">
                                Write your name here.
                            </span>
                            <vue-tel-input
                                :style="{
                                    'border-color': validPhone === 'visible' ? 'red' : '',
                                }"
                                :mode="phoneInputMode"
                                :preferred-countries="['us', 'gb']"
                                :placeholder="phoneCustomPlaceholder"
                                ref="phoneInput"
                                v-model="input.phone"
                                @country-changed="onPhoneCountryChanged"
                            />
                            <span class="validation-error" :style="{ visibility: validPhone }">
                                Write your phone here.
                            </span>
                            <input
                                class="iti iti-email"
                                :style="{
                                    'border-color': validEmail === 'visible' ? 'red' : '',
                                }"
                                type="email"
                                name="email"
                                placeholder="Email"
                                v-model="input.email"
                            />
                            <span class="validation-error" :style="{ visibility: validEmail }">
                                Write your name here.
                            </span>
                            <textarea
                                class="iti"
                                :style="{ 'border-color': validMessage === 'visible' ? 'red' : '' }"
                                name="message"
                                placeholder="Message"
                                v-model="input.message"
                            ></textarea>
                            <span class="validation-error" :style="{ visibility: validMessage }">
                                Write your message here.
                            </span>

                            <button
                                v-if="!showSuccessMessage"
                                class="btn"
                                :class="{ loading: is_submiting }"
                                :disabled="is_submiting"
                                @click="sendMessage"
                            >
                                <BounceSpinner v-if="is_submiting" color="#000" />
                                <span v-else>Send message</span>
                            </button>

                            <div v-if="showSuccessMessage" class="success-message">
                                <span class="success-sent">Your message has been successfully sent.</span>
                                <img src="../../../assets/svgs/success.svg" />
                            </div>
                        </div>
                    </div>
                    <div class="description-block">
                        <img src="../../../assets/svgs/Group 7959.svg" />
                        <div>
                            <p>
                                Our dedicated travel experts are currently standing by to assist you with any of your
                                travel needs or concerns.
                            </p>
                            <p class="remove-margin">
                                Wherever you’re coming from - wherever you want to go, we can get you there comfortably
                                - for up to 60% off! Simply fill in the form below and one of our agents will contact
                                you directly.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import { VueTelInput } from 'vue-tel-input'
import BounceSpinner from './spinners/BounceSpinner'
import PhoneNumber from 'awesome-phonenumber'
import IMask from 'imask'

export default {
    name: 'ContactUs',
    components: {
        VueTelInput,
        BounceSpinner,
    },
    data() {
        return {
            input: {
                name: '',
                phone: '',
                email: '',
                message: '',
            },
            is_submiting: false,
            validName: 'hidden',
            validPhone: 'hidden',
            validEmail: 'hidden',
            validMessage: 'hidden',
            showSuccessMessage: false,
            phoneInputMode: 'international',
            phoneCustomPlaceholder: 'Enter phone number',
            phoneMask: null,
        }
    },
    watch: {
        'input.name'() {
            this.validName = 'hidden'
            this.showSuccessMessage = false
        },
        'input.phone'() {
            this.validPhone = 'hidden'
            this.showSuccessMessage = false
        },
        'input.email'() {
            this.validEmail = 'hidden'
            this.showSuccessMessage = false
        },
        'input.message'() {
            this.validMessage = 'hidden'
            this.showSuccessMessage = false
        },
    },
    mounted() {
        this.phoneMask = IMask(this.$refs.phoneInput.$el.querySelector('.vti__input'), {
            mask: '+1 000 000-0000',
        })
    },
    methods: {
        sendMessage() {
            let hasErrors = false
            if (this.input.name.trim().length < 1) {
                this.validName = 'visible'
                hasErrors = true
            }

            const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            if (!emailRegex.test(this.input.email.trim())) {
                this.validEmail = 'visible'
                hasErrors = true
            }

            if (this.input.phone.trim().length < 6) {
                this.validPhone = 'visible'
                hasErrors = true
            }

            if (this.input.message.trim().length < 6) {
                this.validMessage = 'visible'
                hasErrors = true
            }

            if (!hasErrors) {
                this.is_submiting = true

                axios
                    .post(this.$globalConfig.api.base() + 'a/submit-contact', {
                        ...this.input,
                        ...this.$root.getMarketingData(),
                    })
                    .then(({ data }) => {
                        if (data.success) {
                            this.showSuccessMessage = true

                            setTimeout(() => {
                                this.input.name = ''
                                this.input.email = ''
                                this.input.phone = ''
                                this.input.message = ''
                            }, 2000)

                            this.app.$gtm.trackCustomEvent('gtm-ee-event', {
                                'gtm-ee-event-category': 'contact_form',
                                'gtm-ee-event-action': 'submit',
                            })
                        } else alert('Some error')
                    })
                    .catch((error) => {
                        console.error('Submit error:', error.response)
                    })
                    .finally(() => {
                        this.is_submiting = false
                    })
            }
        },
        onPhoneCountryChanged(payload) {
            const phoneExample = PhoneNumber.getExample(payload.iso2, 'mobile').getNumber(this.phoneInputMode)
            const d = payload.dialCode
            const code = '+' + (d.length === 4 ? d.substr(0, 1) + ' ' + d.substr(1) : d)
            this.phoneCustomPlaceholder = code + phoneExample.split(code)[1].replace(/[0-9]/g, '0')

            this.phoneMask.updateOptions({
                mask: this.phoneCustomPlaceholder,
            })

            if (this.input.phone) {
                this.input.phone = code
                this.phoneMask.value = code
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/global-styles';

.contact {
    width: 100%;
    padding-bottom: 50px;
    padding-top: 50px;
    overflow: hidden;

    .container {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        max-width: 1140px;
        position: relative;

        .title {
            font-family: 'Poppins-Bold', sans-serif;
            font-size: 36px;
            line-height: 55px;
            text-align: center;
            margin: 25px auto;
            position: relative;
        }

        .contact-content {
            display: flex;
            flex-direction: row-reverse;

            .form-block {
                width: 50%;
                margin-top: 50px;

                .form {
                    display: flex;
                    flex-direction: column;

                    .validation-error {
                        padding: 5px 20px;
                        color: red;
                        font-family: 'Gilroy-Regular', sans-serif;
                        font-size: 12px;
                    }

                    .iti-pad {
                        padding: 0 20px;
                        font-size: 16px;
                        color: $mainTextBlueColor;
                    }

                    >>> .vue-tel-input {
                        border-radius: 7px;
                        border: 1px solid #e8e8e8;
                        font-size: 16px;

                        color: $mainTextBlueColor;

                        .vti__dropdown {
                            border-radius: 5px 0 0 5px;

                            &:focus,
                            &:active {
                                outline: none;
                                border-radius: 5px 0 0 5px;
                            }

                            ul {
                                li {
                                    font-family: 'Gilroy-Regular', sans-serif;
                                }
                            }
                        }

                        &:focus-within,
                        &:active {
                            box-shadow: none;
                            border-color: #fae397;
                        }

                        .vti__input {
                            padding-top: 15px;
                            padding-bottom: 15px;
                            border-radius: 5px;

                            &::placeholder {
                                font-family: 'Poppins-Regular', sans-serif;
                                font-size: 16px;
                                color: #757598;
                            }
                        }
                    }

                    .iti {
                        font-family: 'Gilroy-Regular', sans-serif;
                        width: 100%;
                        border-radius: 5px;
                        padding-bottom: 15px;
                        padding-top: 15px;
                        background: #fcfcfc00 0% 0% no-repeat padding-box;
                        border: 1px solid #e2e2e2;
                        outline: none;
                        position: relative;
                        color: $mainTextBlueColor;
                        font-size: 16px;

                        &::placeholder {
                            font-family: 'Poppins-Regular', sans-serif;
                            font-size: 16px;
                            color: #757598;
                        }
                    }

                    .iti:active,
                    .iti:focus {
                        border-color: #fae397;
                    }

                    .iti-email {
                        padding-right: 20px;
                        padding-left: 20px;
                        color: $mainTextBlueColor;
                        font-size: 16px;
                    }

                    textarea {
                        min-height: 148px;
                        padding-right: 20px;
                        padding-left: 20px;
                        margin-bottom: 40px;
                    }
                }

                .success-message {
                    padding-top: 10px;
                    text-align: left;
                    font-family: 'Poppins-SemiBold', sans-serif;
                    font-size: 14px;
                    line-height: 21px;
                    letter-spacing: 0px;
                    color: $mainTextBlueColor;
                    opacity: 1;
                    align-self: center;
                    display: flex;
                    align-items: center;

                    img {
                        padding-left: 20px;
                    }
                }
            }
        }

        .description-block {
            width: 451px;
            height: 278px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: 100px;
            margin-right: 100px;
            font-family: 'Gilroy-Light', sans-serif;
            font-size: 16px;
            line-height: 19px;
            background: #ffffff 0% 0% no-repeat padding-box;
            border-radius: 15px;
            box-shadow: 0px 3px 20px #0000000a;
            opacity: 1;
            position: relative;
            color: $mainTextBlueColor;

            img {
                position: absolute;
                top: -70px;
                left: -70px;
                z-index: -2;
            }

            div {
                align-self: center;

                p {
                    width: 293px;
                    margin-bottom: 16px;
                    margin-block-start: 0;
                    align-self: center;
                }
            }
        }

        @media (max-width: 1200px) {
            max-width: 960px;

            .description-block {
                margin-left: 70px;
            }
        }

        @media (max-width: 992px) {
            max-width: 720px;

            .description-block {
                margin-left: 40px;
            }

            .contact-content {
                .form-block {
                    .btn {
                        padding: 10px 20px;
                    }
                }
            }
        }

        @media (max-width: 768px) {
            max-width: 540px;

            .contact-content {
                flex-direction: column-reverse;

                .form-block {
                    width: 100%;

                    .btn {
                        align-self: center;
                    }

                    .success-message {
                        align-self: center;

                        span {
                            left: 0px;
                        }

                        img {
                            left: 10px;
                        }
                    }
                }

                .description-block {
                    width: 100%;
                    margin: 0;

                    img {
                        z-index: 1;
                    }

                    .remove-margin {
                        margin-bottom: 0;
                    }
                }
            }
        }

        @media (max-width: 540px) {
            max-width: 400px;

            .description-block {
                align-self: center;

                img {
                    width: 70px;
                    top: -20px;
                    left: -20px;
                }

                div {
                    align-self: center;

                    p {
                        padding-left: 5px;
                        width: 265px;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/ContactUs.vue